import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="text-[#7A7571] font-body">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  // First-time password change is mandatory. Redirect to the dedicated page
  // for anyone whose account is still on a system-generated temp password.
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    if (["super_admin", "platform_manager", "platform_staff", "platform_observer", "platform_sales"].includes(user.role))
      return <Navigate to="/admin" replace />;
    if (user.role === "customer") return <Navigate to="/customer" replace />;
    if (user.role === "contractor") return <Navigate to="/contractor" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
